import { Fragment } from 'react';
import { countries } from 'data/countries';
import { isTbd } from 'ui/building/isTbd';
import { Building, BuildingPreview } from 'shared/models';

export type Props = {
    building: Building | null;
};

export function makeAddress<T>(fnPart: (part: string, i: number) => T, fnSeparator: (i: number) => T) {
    return (building: Building | BuildingPreview | null) => {
        if (!building) {
            return [];
        }
        const { streetNumber, streetName, city, region, postalCode, country } = building;
        const countryName = countries[country];

        let streetAddress = null;
        if (!isTbd(streetName)) {
            streetAddress = isTbd(streetNumber) ? streetAddress : `${streetNumber} ${streetName}`;
        }

        const addressParts =
            [ streetAddress, city, region, postalCode, countryName ]
                // Eliminate TBD values (i.e. to avoid "TBD TBD TBD TBD TBD")
                .filter(s => !isTbd(s))
                .map((s, i) => fnPart(s!, i))
        ;
        const separatedParts: T[] = [];
        for (const part of addressParts) {
            separatedParts.push(part);
            separatedParts.push(fnSeparator(separatedParts.length));
        }
        separatedParts.pop();
        return separatedParts;
    };
}

export const makeHtmlAddress = makeAddress(
    (s, i) => <span key={ i }>{ s }</span>,
    i => <span key={ `sep${i}` } className="separator">,&nbsp;</span>,
);

export const makeStringAddress = (building: Building | BuildingPreview | null) => makeAddress(
    s => s,
    i => ', '
)(building).join('');

export const BuildingAddress = ({ building }: Props) => {
    if (!building) {
        return null;
    }
    return (
        <Fragment>
            { makeHtmlAddress(building) }
        </Fragment>
    );
};
